
import HeaderLogo from "@/components/HeaderLogo.vue"
import UseinfoButtonSticky from "@/components/useinfo/UseinfoButtonSticky.vue"
import UseinfoCardThumbnail from "@/components/useinfo/UseinfoCardThumbnail.vue"
import UseinfoCollapseMenu from "@/components/useinfo/UseinfoCollapseMenu.vue"
import UseinfoSliderImage from "@/components/useinfo/UseinfoSliderImage.vue"

import { computed, defineComponent } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  components: { UseinfoCardThumbnail, UseinfoCollapseMenu, HeaderLogo, UseinfoButtonSticky, UseinfoSliderImage },
  setup() {
    const { state } = useStore()
    const isSlideShown = computed(() => state.useinfo.isSlideShown)
    const slideItems = computed(() => state.useinfo.slideItems)

    const slideItem1 = [
      {
        image: require("@/assets/useinfo/img-cardnews-01-1.png"),
        title: "오토콜 하세요!",
        contents: "휴대폰번호를 노출하지 않고도\n주차된 차량에 대한 연락이 가능합니다.",
      },
      {
        image: require("@/assets/useinfo/img-cardnews-01-2.png"),
        contents: "차량에 노출된 전화번호는 무단으로\n수집되어 보이스피싱, 스토킹 등 각종\n범죄에 악용될 수 있습니다.",
      },
      {
        image: require("@/assets/useinfo/img-cardnews-01-3.png"),
        contents: "휴대폰번호와 오토콜 대표번호를\n연동하여 전화번호 유출을 예방하세요!",
      },
    ]
    const slideItem2 = [
      {
        image: require("@/assets/useinfo/img-cardnews-02-1.png"),
        title: "오토콜 하세요!",
        contents: "낯선 사람과의 통화 없이도\n주차된 차량에 대한 연락이 가능합니다.",
      },
      {
        image: require("@/assets/useinfo/img-cardnews-02-2.png"),
        contents: "얼굴, 성별, 나이도 모르는\n낯선 사람과의 통화는\n불편할 수 밖에 없습니다.",
      },
      {
        image: require("@/assets/useinfo/img-cardnews-02-3.png"),
        contents: "통화 없이 호출 받고,\n통화 대신 메시지를 주고 받아\n불편한 상황을 예방하세요!",
      },
    ]
    return {
      slideItem1,
      slideItem2,
      slideItems,
      isSlideShown,
    }
  },
})
